export default function AgreementPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex justify-center">
          <img src="/images/app-logo-2.svg" alt="ThaiSlipCheck" className="h-12" />
        </div>
      </header>

      {/* Content */}
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow-sm p-8 prose prose-gray max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            ข้อตกลงและเงื่อนไขการให้บริการ
          </h1>
          <p className="text-gray-600 mb-8">Terms and Conditions</p>
          <p className="text-gray-700 leading-relaxed">
            <strong>ระบบตรวจสอบสลิปเงินโอนอิเล็กทรอนิกส์ (ThaiSlipCheck)</strong>
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            เว็บไซต์ ThaiSlipCheck.com รวมถึงช่องทางไลน์ และ/หรือช่องทางอื่นที่อาจเพิ่มเติมในอนาคต (ต่อไปนี้เรียกว่า
            "ระบบ ThaiSlipCheck") เป็นบริการที่ให้ผู้ใช้สามารถตรวจสอบสลิปโอนเงินอิเล็กทรอนิกส์
            เพื่อช่วยตรวจสอบความถูกต้องของข้อมูลการโอน
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            การเข้าใช้งานระบบ ThaiSlipCheck การสมัครสมาชิก การส่งสลิปโอนเงิน การเยี่ยมชมเว็บไซต์
            หรือการใช้งานผ่านอุปกรณ์ใด ๆ ถือว่าผู้ใช้บริการ ("ผู้ใช้บริการ" หรือ "ท่าน") ยินยอมปฏิบัติตาม{" "}
            <strong>ข้อตกลงและเงื่อนไขการให้บริการ</strong> ("ข้อตกลงฯ") ฉบับนี้ทั้งหมด
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            <strong>หากท่านไม่ยินยอม โปรดหยุดใช้งานระบบทันที</strong>
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            ผู้ใช้บริการรับทราบว่าข้อตกลงฯ นี้อาจมีการเปลี่ยนแปลงได้ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
            และถือว่าผู้ใช้บริการยอมรับการเปลี่ยนแปลงดังกล่าวโดยอัตโนมัติ
            ผู้ใช้บริการควรติดตามประกาศอัปเดตบนเว็บไซต์อย่างสม่ำเสมอ
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. คำจำกัดความ</h2>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">1.1 บริการระบบ ThaiSlipCheck</h3>
          <p className="text-gray-700 leading-relaxed">
            หมายถึง การให้บริการตรวจสอบสลิปเงินโอนอิเล็กทรอนิกส์ผ่านเว็บไซต์ www.thaislipcheck.com
            และ/หรือช่องทางอื่นที่ผู้ให้บริการกำหนดในอนาคต โดยผู้ใช้ส่งรูปสลิปเงินโอน ("ข้อมูลการโอน")
            เพื่อให้ระบบประมวลผลและแสดงข้อมูลประกอบการตรวจสอบ
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">1.2 บัญชีผู้ใช้บริการ</h3>
          <p className="text-gray-700 leading-relaxed">
            หมายถึง บัญชีร้านค้า/บุคคลที่สมัครเป็นสมาชิกระบบ ThaiSlipCheck
            เพื่อใช้งานตรวจสอบสลิปเงินโอนและใช้บริการเสริมตามที่ ThaiSlipCheck กำหนด
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">1.3 ผู้ใช้บริการ</h3>
          <p className="text-gray-700 leading-relaxed">
            หมายถึง บุคคลธรรมดาหรือนิติบุคคลที่สมัครใช้งานระบบ ThaiSlipCheck ไม่ว่าจะใช้ในนามส่วนตัว
            หรือได้รับอำนาจให้ดำเนินการแทน
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">1.4 รหัสบัญชีผู้ใช้</h3>
          <p className="text-gray-700 leading-relaxed">
            หมายถึง เบอร์โทรศัพท์ อีเมล ชื่อผู้ใช้ และรหัสผ่านที่ตั้งขึ้นเพื่อยืนยันตัวตนเข้าระบบ
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. การให้บริการ</h2>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">2.1 ลักษณะบริการ</h3>
          <p className="text-gray-700 leading-relaxed">
            ThaiSlipCheck เป็นซอฟต์แวร์ให้บริการตรวจสอบสลิปโอนเงินอิเล็กทรอนิกส์
            โดยผู้ใช้ส่งข้อมูลการโอนเข้าสู่ระบบ และระบบจะแจ้งผลผ่านเว็บหรือช่องทางอื่นที่กำหนด
            รวมถึงแสดงรายงานย้อนหลังและข้อมูลประกอบการตรวจสอบ
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">2.2 ความรับผิดชอบของผู้ใช้บริการ</h3>
          <p className="text-gray-700 leading-relaxed">
            ThaiSlipCheck เป็นเพียงผู้ให้บริการระบบตรวจสอบข้อมูลเบื้องต้น <strong>ไม่ใช่</strong>{" "}
            ผู้ยืนยันธุรกรรมทางการเงินหรือผู้รับผิดชอบต่อการซื้อขายสินค้า/บริการของร้านค้า
            หากเกิดความเสียหายจากการซื้อขาย ผู้ใช้บริการจะไม่สามารถเรียกร้องต่อ ThaiSlipCheck ได้
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. ระบบสมาชิกและค่าบริการ</h2>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">3.1 การสมัครสมาชิก</h3>
          <p className="text-gray-700 leading-relaxed">
            ผู้ใช้จำเป็นต้องลงทะเบียนผ่านเว็บไซต์ โดยระบุข้อมูลที่จำเป็นเพื่อประโยชน์ในการใช้งาน
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">3.2 แพ็กเกจสมาชิกและค่าบริการ</h3>
          <p className="text-gray-700 leading-relaxed">
            ผู้ใช้สามารถเลือกซื้อแพ็กเกจเพื่อใช้งานระบบ โดยชำระผ่านวิธีที่ ThaiSlipCheck กำหนด
            ผู้ใช้จะได้รับสิทธิใช้งานตามแพ็กเกจที่เลือก
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">3.3 การต่ออายุบริการ</h3>
          <p className="text-gray-700 leading-relaxed">
            หากหมดอายุแพ็กเกจและไม่ได้ชำระเพื่อใช้งานต่อ ระบบอาจถูกระงับจนกว่าจะต่ออายุ
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. เครดิต (Credit)</h2>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">4.1 การเติมเครดิต</h3>
          <p className="text-gray-700 leading-relaxed">
            ผู้ใช้สามารถเติมเครดิตผ่านวิธีชำระเงินที่ ThaiSlipCheck กำหนด โดยเครดิต 1 หน่วย = 1 บาท
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">4.2 ตรวจสอบยอดเครดิต</h3>
          <p className="text-gray-700 leading-relaxed">ระบบจะแสดงยอดเครดิตในบัญชีผู้ใช้</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. การยกเลิกสมาชิก</h2>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">5.1 วิธีการยกเลิก</h3>
          <p className="text-gray-700 leading-relaxed">
            ผู้ใช้สามารถยกเลิกได้ผ่านฝ่ายบริการลูกค้า โดยการยกเลิกมีผลเมื่อหมดอายุแพ็กเกจปัจจุบัน และ{" "}
            <strong>ไม่สามารถขอคืนค่าบริการที่ใช้ไปแล้วได้</strong>
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. นโยบายคืนเงิน</h2>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">
            6.1 ไม่คืนเงินในทุกกรณี ยกเว้นบัญชีถูกยกเลิกตามข้อกำหนด
          </h3>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">6.2 ค่าธรรมเนียม</h3>
          <p className="text-gray-700 leading-relaxed">
            หากเข้าเงื่อนไขคืนเงิน จะหักค่าธรรมเนียม 15% หรือขั้นต่ำ 300 บาท
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">6.3 การดำเนินการคืนเงิน</h3>
          <p className="text-gray-700 leading-relaxed">ภายใน 30 วันหลังยกเลิกสถานะสมาชิก</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. การใช้งานระบบ</h2>
          <p className="text-gray-700 leading-relaxed">ผู้ใช้ตกลงว่า:</p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>จะเก็บรหัสดังกล่าวไว้เป็นความลับ</li>
            <li>จะไม่คัดลอก ดัดแปลง ทำวิศวกรรมย้อนกลับ หรือรบกวนระบบ</li>
            <li>
              จะไม่ละเมิดลิขสิทธิ์ เครื่องหมายการค้า หรือทรัพย์สินทางปัญญาใด ๆ ของ ThaiSlipCheck
            </li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-4">
            หากฝ่าฝืน ThaiSlipCheck มีสิทธิระงับบริการทันที
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. การระงับหรือยุติการให้บริการ</h2>
          <p className="text-gray-700 leading-relaxed">
            ThaiSlipCheck อาจปรับปรุงระบบ ระงับ หรือเปลี่ยนแปลงบริการได้โดยไม่แจ้งล่วงหน้า
          </p>
          <p className="text-gray-700 leading-relaxed mt-4">
            หากพบการละเมิดข้อตกลงฯ ThaiSlipCheck
            สามารถระงับบัญชีหรือยุติการให้บริการได้ทันทีโดยไม่ต้องรับผิดชอบค่าเสียหายใด ๆ
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. การคุ้มครองข้อมูลส่วนบุคคล</h2>
          <p className="text-gray-700 leading-relaxed">
            ข้อมูลใด ๆ ที่ผู้ใช้ส่งเข้าระบบจะได้รับความคุ้มครองตาม <strong>นโยบายความเป็นส่วนตัว (Privacy Policy)</strong> ของ ThaiSlipCheck
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">10. ข้อยกเว้นความรับผิด</h2>
          <p className="text-gray-700 leading-relaxed">ThaiSlipCheck ไม่รับผิดชอบต่อ:</p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>ความล่าช้า/ขัดข้องของอินเทอร์เน็ต</li>
            <li>ความผิดพลาดของระบบธนาคาร</li>
            <li>การโจมตีโดยแฮกเกอร์</li>
            <li>การหยุดบริการเพื่อปรับปรุงระบบ</li>
            <li>ความเสียหายจากบุคคลที่สาม</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">11. ข้อกำหนดทั่วไป</h2>
          <p className="text-gray-700 leading-relaxed">
            ข้อความใดในข้อตกลงใช้ไม่ได้ตามกฎหมาย ข้อกำหนดอื่นยังคงบังคับใช้ได้
            <br />
            การสละสิทธิ์บางประการไม่ถือเป็นการสละสิทธิ์ทั้งหมด
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">12. ข้อห้ามในการใช้งาน</h2>
          <p className="text-gray-700 leading-relaxed">
            ผู้ใช้ <strong>ห้ามนำบริการไปใช้</strong> ร่วมกับกิจกรรมที่ผิดกฎหมาย เช่น
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>การพนัน</li>
            <li>สินค้าอบายมุขหรือผิดกฎหมาย</li>
            <li>สินทรัพย์ดิจิทัลที่ไม่ได้รับอนุญาต</li>
            <li>สื่อลามกอนาจาร</li>
            <li>การนำระบบไปปล่อยเช่า/ขายต่อโดยไม่ได้รับอนุญาต</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">13. กฎหมายที่ใช้บังคับ</h2>
          <p className="text-gray-700 leading-relaxed">ข้อตกลงนี้อยู่ภายใต้กฎหมายไทย</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">14. ช่องทางติดต่อ</h2>
          <p className="text-gray-700 leading-relaxed">หากมีข้อสงสัย ติดต่อได้ที่</p>

          <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mt-4">
            <h4 className="font-semibold text-gray-900 mb-3">
              บริษัท อีซี่ เทค อีเลฟเว่น จำกัด (สำนักงานใหญ่)
            </h4>
            <p className="text-gray-700 leading-relaxed">
              เลขที่ 18 ซอยประชาชื่นนนทบุรี 8 แยก 1
              <br />
              ตำบลบางเขน อำเภอเมืองนนทบุรี
              <br />
              จังหวัดนนทบุรี 11000
            </p>
            <p className="text-gray-700 mt-2">
              <strong>โทร:</strong> 084-3618424
            </p>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">15. การปรับปรุง</h2>

          <div className="mt-8 pt-6 border-t border-gray-200 text-center text-sm text-gray-500">
            อัปเดตล่าสุด: ธันวาคม 2568
          </div>
        </div>
      </main>
    </div>
  );
}
